//
import Service from '@/services/service'
import ProviderDebtToPayPendingModel from '@/models/Purchase/PchProviderDebtToPayPending'

/**
 * This class describes a pch provider debt to pay pending.
 *
 * @class      PchProviderDebtToPayPending (name)
 */
export default class PchProviderDebtToPayPending extends Service {

  /**
   * { function_description }
   *
   * @return     {<type>}  { description_of_the_return_value }
   */
  resource() {
    return ProviderDebtToPayPendingModel
  }

  /**
   * Returns a list representation of the object.
   *
   * @return     {<type>}  List representation of the object.
   */
  toList() {
  	return this
  		.include(
        'pch_provider',
        'pch_purchase_invoice',
        'pch_purchase_debit_note',
  		)
  }
}
